import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useProject() {
    const { data } = useQuery(queries.project.detail());
    return data;
}

export default useProject;
